import React, { Component } from 'react'

import { connect } from 'react-redux'
import moment from 'moment'
import i18n from 'i18n-js';
import { Spinner, Button } from 'react-bootstrap';
import Modal from 'react-bootstrap/Modal';

import { AppState } from '../../types'
import { NavigationState } from '../../modules/navigation/types'

import CalendarFormBooking from '../Components/Booking/CalendarFormBooking';
import Checkout from '../Components/Booking/Checkout';
import { API } from '../../api/api';

import PaymentForm from '../Components/Booking/PaymentForm'

interface MyProps {

}

interface MyState {
  dateFrom: string;
  dateTo: string;
  isCheckout: boolean;
  checkoutIndex: number;
  userBookingInformation: any;
  form: any;
  isLogin: boolean;
  count: number;
  solutionValue: number;
  solutionData: any;
  couponValue: string;
  // dogsValue: any;
  dogsList: any;
  notAvailable: [];
  isClick: boolean;
  isBookingSuccess: boolean;
  bookingInfoCalcData: any;
  bookingInfoCalcDataLoading: boolean;
  dogCount: number;
  // selectedDogs: [];
  userCalendar: any;
  userCalendar2: any;
  message: object;
  currentUser: object;
  dogForm: object;
  isSubmitAddDog: boolean;
  bookingSpecialType: [string, string, string];
  selectedBookingDates: [];
  calendarDateStop: string;
  currentUserLoading: boolean;
  dogsitterId: any;
  errorAPIDown: boolean;
  lessThan24hr: boolean;
  dogArr: any;
  isLoadingModal: boolean;
  errorModal: boolean;
  isCoupon: boolean;
  paymentArgs: {
    result: any;
    status: number;
  };
}

interface ValData {
  result: any;
}

class App extends Component<MyProps, MyState> {
  constructor(props: Readonly<MyProps>) {
    super(props);

    // const urlParams = new URLSearchParams(window.location.search);
    // const dogsitterId = urlParams.get('tx_dogleybooking_booking[userProfile]');
    const d: any = document;
    const dogsitterId = d.getElementById("dogsitter-id").value;

    this.state = {
      bookingSpecialType: [
        "walkPrice",
        "dayPrice",
        "visitPrice"
      ],
      selectedBookingDates: [],
      dateFrom: localStorage.getItem('dogsitterId') === dogsitterId && localStorage.getItem('dateFrom') ? localStorage.getItem('dateFrom') : null,
      dateTo: localStorage.getItem('dogsitterId') === dogsitterId && localStorage.getItem('dateTo') ? localStorage.getItem('dateTo') : null,
      isCheckout: false,
      checkoutIndex: 1,
      userBookingInformation: null,
      isLogin: false,
      form: {},
      count: 1,
      solutionValue: localStorage.getItem('dogsitterId') === dogsitterId && parseInt(localStorage.getItem('solutionValue')) ? parseInt(localStorage.getItem('solutionValue')) : null,
      couponValue: null,
      // dogsValue: [],
      dogsList: [],
      notAvailable: [],
      isClick: false,
      isBookingSuccess: false,
      bookingInfoCalcData: null,
      bookingInfoCalcDataLoading: false,
      dogCount: null,
      // selectedDogs: [],
      userCalendar: null,
      userCalendar2: null,
      message: null,
      currentUser: null,
      dogForm: null,
      isSubmitAddDog: false,
      calendarDateStop: null,
      currentUserLoading: false,
      solutionData: null,
      dogsitterId: dogsitterId,
      errorAPIDown: false,
      dogArr: [],
      lessThan24hr: false,
      isLoadingModal: false,
      errorModal: false,
      paymentArgs: null,
      isCoupon: false
    }

    localStorage.removeItem('dogsitterId');
    localStorage.removeItem('dateFrom');
    localStorage.removeItem('dateTo');
    localStorage.removeItem('solutionValue');

    this.confirmBooking = this.confirmBooking.bind(this);
    this.setStateValue = this.setStateValue.bind(this);
    this.changeCheckoutForm = this.changeCheckoutForm.bind(this);
    this.submitBooking = this.submitBooking.bind(this);
    this.getUserCalendar = this.getUserCalendar.bind(this);
    this.getUserCalendar2 = this.getUserCalendar2.bind(this);
    this.resetState = this.resetState.bind(this);
    this.submitAddDog = this.submitAddDog.bind(this);
    this.bookingInfoCalc = this.bookingInfoCalc.bind(this);
  }

  async componentWillMount() {

    // document.body.innerHTML += '<div className="modal-loading"><div className="modal-loading-inner"><Spinner animation="grow" variant="primary" /></div></div>';
    await this.defaultCalendar();
    await this.getUserInfo();

    const { currentUser, form, dogsitterId, userBookingInformation }: any = this.state;
    const tempVal: any = [];

    const currency = this.getCurrency();

    // @ts-ignore
    fbq('track', 'ViewContent', {
      content_name: userBookingInformation.dogsitter.name,
      content_category: 'Dog sitter',
      content_ids: [dogsitterId],
      content_type: 'product',
      value: 0,
      currency: currency
    });

    if (currentUser) {
      let dogsList = currentUser.dogs;
      // let dogCount = 0;

      if (dogsList.length) {
        for(let x = 0; x < dogsList.length; x++) {
          tempVal.push(
            {
              value: dogsList[x].uid,
              label: dogsList[x].name,
            }
          );
        }
        if (!dogsList.length) {
          dogsList = null;
        }
        // dogCount = dogsList.legnth;
      }

      await this.setState({
        dogCount: tempVal.length,
        dogsList: tempVal,
        form: Object.assign(form, {
          dogsValue: {
            value: tempVal,
            required: true,
            errorMessage: '',
            name: 'dogsValue'
          }
        })
      });
      this.bookingInfoCalc();
    }

    this.dogForm();
  }

  dogForm() {
    API.dogForm()
    .then((response: any) => {
      this.setState({ dogForm: response.result });
    })
    .catch(async(e) => {
      await this.responseAPIDown(e);
      this.setState({ dogForm: null });
    });
  }

  async responseAPIDown(e: any) {
    console.log('err', e)
    if (e.isError) {
      await this.setState({ errorAPIDown: true, isLoadingModal: false });
      alert(e.error.message)
    } else {
      await this.setState({ errorAPIDown: false, isLoadingModal: false });
    }
  }

  async getUserInfo() {
    this.setState({ currentUserLoading: true })
    await API.getUserInfo()
    .then((response: any) => {
      const data = response.result;

      const arrlist = [];

      if (data.dogs && data.dogs.length) {
        for(let x = 0; x < data.dogs.length; x++) {
          arrlist.push({
            value: data.dogs[x].uid,
            label: data.dogs[x].name,
          });
        }
      }

      this.setState({
        dogArr: arrlist,
        currentUser: data,
        currentUserLoading: false,
      })
    })
    .catch(async(e) => {
      await this.responseAPIDown(e);
      this.setState({
        dogArr: [],
        currentUser: null,
        currentUserLoading: false,
      })
    });
  }

  async defaultCalendar() {
    const { calendarDateStop } = this.state;
    const startDate = calendarDateStop ? calendarDateStop : String(moment().format('YYYY-MM-')) + '1';
    const endDate =
      calendarDateStop ?
        calendarDateStop
        :
        String(moment().format('YYYY-MM-')) +
        moment()
          .endOf('month')
          .format('DD');

    this.getUserCalendar(startDate, endDate);
    this.getUserCalendar2(startDate, endDate);
    await this.getBookingDetail();
  }

  async bookingInfoCalc() {
    const {
      solutionValue,
      dateFrom,
      dateTo,
      dogCount,
      selectedBookingDates,
      // dogsList,
      form,
      currentUser,
      userBookingInformation,
      dogsitterId
    } = this.state;
    // this.setState({ bookingInfoCalcData: null });
    // if (dateFrom && dateTo && dogCount || (selectedBookingDates.length && dogCount)) {
      // const urlParams = new URLSearchParams(window.location.search);
      // const dogsitterId = urlParams.get('tx_dogleybooking_booking[userProfile]');
      let isFulldayPrice = false;

      if (userBookingInformation && userBookingInformation.solutions) {
        for(let x=0; x < userBookingInformation.solutions.length; x++) {
          if (userBookingInformation.solutions[x].uid === solutionValue && userBookingInformation.solutions[x].priceColumn === "fullDayPrice"
            && dateFrom && dateTo && (moment(dateTo, 'YYYY-MM-DD').diff(moment(dateFrom, 'YYYY-MM-DD'), 'days') <= 1)) {
            isFulldayPrice = true;
            break;
          }
        }
      }

      if (!isFulldayPrice) {
        await this.setState(
          {
            lessThan24hr: false
          }
        )
      }

      const bParams = {
      	dogsitter: parseInt(dogsitterId),
      	solution: solutionValue,
        fromdate: dateFrom,
        todate: dateTo,
        dates: selectedBookingDates.length ? selectedBookingDates : null,
      	dogCount: form.dogsValue && form.dogsValue.value ? form.dogsValue.value : [{"value": 1, "label": ""}],
        lessThan24hr: this.state.lessThan24hr
      };

      this.setState({ bookingInfoCalcDataLoading: true });

      let isCalculate: any = false;

      if (currentUser) {
        isCalculate = (dogsitterId && solutionValue && dateFrom && dateTo && dogCount) || (dogsitterId && solutionValue && dogCount && selectedBookingDates.length) ? true : false;
      } else {
        isCalculate = solutionValue ? true : false;
      }

      if (isCalculate) {
        API.bookingInfoCalc(bParams)
          .then(async(response: any) => {
            await this.setState(
              {
                bookingInfoCalcData: response.result,
                bookingInfoCalcDataLoading: false,
                dogCount: bParams.dogCount.length,
                dogsList: form.dogsValue && form.dogsValue.value ? form.dogsValue.value : []
              });
          })
          .catch(async(e) => {
            await this.responseAPIDown(e);
            this.setState({ bookingInfoCalcData: null, bookingInfoCalcDataLoading: false });
          });
      } else {
        this.setState({ bookingInfoCalcData: null, bookingInfoCalcDataLoading: false });
      }
    // }
  }

  getUserCalendar(startDate: string, endDate: string) {
    // const urlParams = new URLSearchParams(window.location.search);
    // const dogsitterId = urlParams.get('tx_dogleybooking_booking[userProfile]');
    const { dogsitterId } = this.state;

    this.setState({ userCalendar: null, calendarDateStop: startDate });

    API.getUserCalendar(startDate, endDate, dogsitterId)
      .then((response: any) => {
        this.setState({ userCalendar: response.result })
      })
      .catch(async(e) => {
        await this.responseAPIDown(e);
      });
  }

  getUserCalendar2(startDate: string, endDate: string) {
    // const urlParams = new URLSearchParams(window.location.search);
    // const dogsitterId = urlParams.get('tx_dogleybooking_booking[userProfile]');
    const { dogsitterId } = this.state;

    this.setState({ userCalendar2: null });

    API.getUserCalendar(startDate, endDate, dogsitterId)
      .then((response: any) => {
        this.setState({ userCalendar2: response.result })
      })
      .catch(async(e) => {
        await this.responseAPIDown(e);
      });
  }

  async getBookingDetail() {
    const { solutionValue, errorAPIDown, dogsitterId } = this.state;
    // const urlParams = new URLSearchParams(window.location.search);
    // const dogsitterId = urlParams.get('tx_dogleybooking_booking[userProfile]');
    // API.getBooking(startDate, endDate, dogsitterId)
    await API.getBooking(dogsitterId)
      .then((response: ValData) => {

        if (response.result.owner && response.result.owner.dogs) {
          this.setState({ selectedBookingDates: [] });
        }

        this.setState({
          userBookingInformation: response.result,
          solutionValue: solutionValue ? solutionValue : response.result.solutions ? response.result.solutions[0].uid : null,
          // isCheckout: true,
        });
      })
      .catch(async(e) => {
        await this.responseAPIDown(e);
      });

    if (!errorAPIDown) {
      API.isAuthenticated()
        .then((response: ValData) => {
          this.setState({ isLogin: response.result });
        })
        .catch(async(e) => {
          await this.responseAPIDown(e);
        });
    }
  }

  setLocalStorage() {
    const { currentUser, solutionValue, dateTo, dateFrom, dogsitterId } = this.state;

    if (!currentUser) {
      // const urlParams = new URLSearchParams(window.location.search);
      // const dogsitterId = urlParams.get('tx_dogleybooking_booking[userProfile]');
      localStorage.setItem('dateFrom', dateFrom ? dateFrom : '');
      localStorage.setItem('dateTo', dateTo ? dateTo : '');
      localStorage.setItem('solutionValue', solutionValue ? String(solutionValue) : '');
      localStorage.setItem('dogsitterId', dogsitterId ? dogsitterId : '');
    }
  }

  async setStateValue(value: object, isCalculate = false) {
    await this.setState(value);

    this.setLocalStorage();

    if (isCalculate) {
      this.bookingInfoCalc();
    }

  }

  async submitAddDog() {
    const { form } = this.state;

    let value: any = {};
    let isError = false;

    for (value in form) {
      if (form[value].required && !form[value].value) {
        form[value].errorMessage = `${form[value].label} Skal udfyldes`;
        isError = true;
      }
    }

    this.setState(form);

    if (!isError) {
      const bParams = {
      	name: form.dogName ? form.dogName.value : '',
      	description: form.dogDescription ? form.dogDescription.value : '',
      	race: form.dogRace ? parseInt(form.dogRace.value) : '',
      	gender: form.dogGender ? form.dogGender.value : '',
      	size: form.dogSize ? parseInt(form.dogSize.value, 10) : '',
      	dateofbirth: form.dateOfBirth ? form.dateOfBirth.value : '',
      	otherInfo: form.dogOtherImportant ? form.dogOtherImportant.value : '',
      	vetInfo: form.dogVetname ? form.dogVetname.value : '',
      	media: form.dogImage ?form.dogImage : '',
      };

      this.setState({ isSubmitAddDog: true });
      try {
        await API.addDog(bParams);
        this.defaultCalendar();
        this.getUserInfo();

        this.setState({ isSubmitAddDog: false });
        return true;

      } catch(e) {
        await this.responseAPIDown(e);
        await this.getUserInfo();

        this.setState({ dogForm: null });
        this.setState({ isSubmitAddDog: false });
        console.log(e)
        return false;
      }
    }
  }

  validateForm(form: any, ) {
    let val: any = '';
    let isError = false;

    for (val in form) {
      if (typeof form[val] === 'object') {
        const { label = '', name, value, required } = form[val];
        const arr = [];

        let errorMessage = '';
        // if (required && !value) {
        if (required && !value) {
          errorMessage = (`${label} Skal udfyldes`).trim();
          isError = true;
        }

        arr[name] =
          {
            value: value,
            label,
            name,
            errorMessage,
            required
          };

        this.setStateValue({ form: Object.assign(form, arr) });
      }
    }

    return isError;
  }

  async submitBooking(key: any) {
    const { form, count, solutionValue, dateFrom, dateTo, couponValue, isClick, message, selectedBookingDates, checkoutIndex, lessThan24hr, isLoadingModal, dogsitterId } : any = this.state;

    if (!isClick) {
      this.setState({ isClick: true });
      // const urlParams = new URLSearchParams(window.location.search);
      // const dogsitterId = urlParams.get('tx_dogleybooking_booking[userProfile]');

      switch(key) {
        case 'submit':
          try {
            const err = this.validateForm(form);
            if (!isLoadingModal) {
              if (!err) {
                const bParams = {
                  firstName: form.firstName.value,
                  middleName: form.middleName.value,
                  lastName: form.lastName.value,
                  address: form.address.value,
                  telephone: form.telephone.value,
                  zip: form.zip.value,
                  city: form.city.value,
                };

                await this.setState({ isLoadingModal: true });

                await API.updateUserProfile(bParams);

                let dogsId = [];
                if (form.dogsValue.value) {
                  dogsId = form.dogsValue.value.map((val: any) => {
                    return val.value;
                  });
                }

                const submitbParams: any = {
                  dogsitter: parseInt(dogsitterId),
                  dogs: dogsId,
                  coupon: couponValue,
                  solution: solutionValue,
                  bodytext: message && message.value ? message.value : '',
                  lessThan24hr: lessThan24hr,
                  dogleyCoins: form.dogleyCoins && form.dogleyCoins.value ? form.dogleyCoins.value : 0
                };

                if (selectedBookingDates.length) {
                  submitbParams.dates = selectedBookingDates;
                } else {
                  submitbParams.fromdate = dateFrom;
                  submitbParams.todate = dateTo;
                }

                const respSumbitBooking: any = await API.submitBooking(submitbParams);

                let bookingId = null;

                if (respSumbitBooking.result.length) {
                  bookingId = respSumbitBooking.result.map((val: any) => {
                    return val.uid;
                  });
                  bookingId = bookingId.join('/');
                } else {
                  bookingId = respSumbitBooking.result.uid;
                }

                let calc: any = this.getTotalPrice();

                const currency = this.getCurrency();

                // @ts-ignore
                fbq('track', 'Purchase', {
                  value: calc.totalPrice,
                  currency: currency,
                });

                // const respGetPaymentBooking: any = await API.getPaymentBooking(bookingId);
                // const respGetPaymentBooking: any = await API.getPaymentForm(bookingId);
                const paymentArgs: any = await API.getPaymentFormArgs(bookingId)

                this.getBookingDetail();
                this.setState({
                  paymentArgs,
                  isBookingSuccess: true,
                  dateFrom: null,
                  dateTo: null,
                  bookingInfoCalcData: null,
                  // checkoutIndex: 1,
                  count: 1,
                  // isLoadingModal: false,
                  // isCheckout: false,
                });

                this.defaultCalendar();

                // var paymentForm: Document = new DOMParser().parseFromString(
                //   respGetPaymentBooking, "text/xml"
                // );
                // console.log(paymentForm);
                // paymentForm.submit();

                // window.location.href = respGetPaymentBooking.result;
                // window.open(respGetPaymentBooking.result, '_blank');
              }
            }
          } catch(e) {
            await this.responseAPIDown(e);
            console.log(e)
          }

          break;

        // case 3:
        //   const err = this.validateForm(form);
        //
        //   if (!err) {
        //     this.setState({ checkoutIndex: key, count: count + 1 });
        //     // this.setState({ message: { label: i18n.t('messageToDogsitter'), value: message.value, error: true, errorMessage: null } });
        //   // } else {
        //     // this.setState({ message: { label: i18n.t('messageToDogsitter'), value: '', error: true, errorMessage: (`${i18n.t('messageToDogsitter')} Skal udfyldes`).trim() } });
        //   }
        //
        //   break;

        case 2:

          let newForm = form;

          if (checkoutIndex === 1) {
            delete newForm.address;
            delete newForm.zip;
            delete newForm.city;

            await this.setState({ form:  newForm})
          }

          const isError = this.validateForm(this.state.form);

          if (isError) {
            this.bookingInfoCalc();
            this.setState({ checkoutIndex: 1, count: 1 });
            break;
          }

        default:
          this.setState({ checkoutIndex: key, count: count + 1 });
          this.bookingInfoCalc();
      }

      this.setState({ isClick: false });
    }
  }

  updateState(value: object) {
    const { form } = this.state;
    this.setState(value);
    this.setState({
      form: Object.assign(form, {
        dogsValue: {
          value: '',
          required: form.dogsValue.required,
          errorMessage: '',
          name: form.dogsValue.name
        }
      })
    });
  }

  async selectDate(date: string, str: string) {
    const { dateFrom, dateTo } = this.state;

    // if (dateFrom || dateTo) {
    //   let from = new Date(dateFrom);
    //   let to = new Date(dateTo);
    //   let isCheckout = false;
    //
    //   switch(str) {
    //     case 'from':
    //       from = new Date(date);
    //       break;
    //
    //     case 'to':
    //       to = new Date(date);
    //       break;
    //   }
    //
    //   // if (from > to) {
    //   //   // isCheckout = true;
    //   //   alert('Invalid date');
    //   //   return false;
    //   // }
    //
    //   // this.setState({ isCheckout: isCheckout });
    // }

    switch(str) {
      case 'from':
        await this.setState({ dateFrom: date });
        this.setLocalStorage();
        break;

      case 'to':
        await this.setState({ dateTo: date });
        this.setLocalStorage();
        break;

      case 'bookingSpecialType':
        const { selectedBookingDates } = this.state;
        let data: any = selectedBookingDates;
        const index = data.indexOf(date);
        if (index >= 0) {
          delete data[index];
        } else {
          data.push(date);
        }

        data = data.filter((n: any) => n);
        await this.setState({ selectedBookingDates: data });

        break;
    }

    this.bookingInfoCalc();
  }

  checkExtraPrice(isAlert: boolean = false) {
    const { userBookingInformation, solutionValue, dogCount } = this.state;
    let has = false;

    if (userBookingInformation && userBookingInformation.solutions) {
      for(let x=0; x < userBookingInformation.solutions.length; x++) {
        if (userBookingInformation.solutions[x].uid === solutionValue && !userBookingInformation.solutions[x].ableToAddMoreDog) {
          if (dogCount > 1) {
            has = true

            if (isAlert) {
              this.setState({ errorModal: true });
              // alert(i18n.t('thisDogSitterDoesNotTake1MoreDog'));
            }
          }

          break;
        }
      }
    }

    if (has) {
      return true;
    }

    return false;
  }

  getTotalPrice() {
    const { bookingInfoCalcData } = this.state;
    let totalPrice = 0;
    let res = {};

    if (bookingInfoCalcData.length) {
      Object.keys(bookingInfoCalcData).map((key) =>
      {
        res = {
          totalPrice: totalPrice + parseInt(bookingInfoCalcData[key].price, 10),
          totalPriceCurrency: bookingInfoCalcData[key].currency,
        }
      });
    } else {
      res = {
        totalPrice: totalPrice + parseInt(bookingInfoCalcData.price, 10),
        totalPriceCurrency: bookingInfoCalcData.currency,
      }
    }

    return res;
  }

  getCurrency() {
    let currency = 'DKK';

    switch (i18n.locale) {
      case 'da' :
        currency = 'DKK';
        break;

      case 'no' :
        currency = 'NOK';
        break;

      case 'se' :
        currency = 'SEK';
        break;
    }

    return currency;
  }

  confirmBooking() {
    const { dogCount, bookingInfoCalcData, dogsList, bookingInfoCalcDataLoading, userBookingInformation, dogsitterId } = this.state;
    if (!dogCount) {
      alert(i18n.t('chooseDog'));
      return;
    }

    if (bookingInfoCalcDataLoading) {
      return;
    }

    if (this.checkExtraPrice(true)) {
      return;
    }

    let isSubmit = false;

    if (bookingInfoCalcData && bookingInfoCalcData.available) {
      isSubmit = true;
    }

    if (bookingInfoCalcData && bookingInfoCalcData.length) {
      isSubmit = true;
    }

    if (isSubmit) {
      let calc: any = this.getTotalPrice();

      const currency = this.getCurrency();

      // @ts-ignore
      fbq('track', 'AddToCart', {
        content_name: userBookingInformation.dogsitter.name,
        content_category: 'Dog sitter',
        content_ids: [dogsitterId],
        content_type: 'product',
        value: calc.totalPrice,
        currency: currency
      });

      this.setState({
        isCheckout: true,
        form: {
          dogsValue: {
            value: dogsList,
            errorMessage: '',
            required: true,
            name: 'dogsValue'
          }
        },
      });
    } else {
      alert(i18n.t('pleaseSelectDate'));
    }
  }

  changeCheckoutForm(index: number) {
    const { count } = this.state;

    if (count >= index) {
      this.setState({ checkoutIndex: index});
    }
  }

  resetState() {
    // const { form } = this.state;

    this.setState({
      form: {}
    })
  }

  async getPaymentForm(bookingId: string) {
    const respGetPaymentBooking: any = await API.getPaymentFormArgs(bookingId)
    return respGetPaymentBooking
  }

  render() {
    const { isCheckout, checkoutIndex, isLoadingModal, errorModal, paymentArgs } = this.state;
    // if (!currentUser && !currentUserLoading) {
    //   const urlParams = new URLSearchParams(window.location.search);
    //   const dogsitterId = urlParams.get('tx_dogleybooking_booking[userProfile]');
    //   localStorage.setItem('dateFrom', dateFrom);
    //   localStorage.setItem('dateTo', dateTo);
    //   localStorage.setItem('solutionValue', String(solutionValue));
    //   localStorage.setItem('dogsitterId', dogsitterId);
    //   // dateFrom, dateTo, solutionValue
    // }

    return (
      <div className="box-booking">
        {paymentArgs && <PaymentForm {...paymentArgs} />}

        <div className={isLoadingModal ? 'modal-loading show' : 'modal-loading hide'}>
          <div className="modal-loading-inner"><Spinner animation="grow" variant="primary" /></div>
        </div>

        <Modal
          aria-labelledby="contained-modal-title-vcenter"
          centered
          show={errorModal}
          onHide={() => this.setState({ errorModal: false })}
          className="box-modal-error-booking"
        >
          <Modal.Header closeButton>
            <Modal.Title>{i18n.t('message')}</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="box-modal-error-booking-inner">
              <p>{i18n.t('thisDogSitterDoesNotTake1MoreDog')}</p>
            </div>
          </Modal.Body>
          <Modal.Footer>
           <div className="box-btn">
             <button className="white" onClick={() => this.setState({ errorModal: false })}>
               {i18n.t('close')}
             </button>
           </div>
         </Modal.Footer>
        </Modal>
        <div className="box-booking-inner">
          <CalendarFormBooking
            // notAvailable={notAvailable}
            selectDate={this.selectDate.bind(this)}
            // dateFrom={dateFrom}
            // dateTo={dateTo}
            setStateValue={this.setStateValue}
            confirmBooking={this.confirmBooking}
            getUserCalendar={this.getUserCalendar}
            getUserCalendar2={this.getUserCalendar2}
            resetState={this.resetState}
            submitAddDog={this.submitAddDog}
            bookingInfoCalc={this.bookingInfoCalc}
            {...this.state}
          />
          <Checkout
            show={isCheckout}
            setStateValue={this.setStateValue}
            onHide={
              this.updateState.bind(this, {
                isCheckout: false,
                checkoutIndex: 1,
                count: 1,
                isBookingSuccess: false,
                message: {},
              })
            }
            changeCheckoutForm={this.changeCheckoutForm}
            checkoutIndex={checkoutIndex}
            submitBooking={this.submitBooking}
            {...this.state}
          />
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state: AppState): { navigation: NavigationState } => ({
  navigation: state.navigation
})

export default connect(mapStateToProps)(App)
